'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'user-headset';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f82d';
var svgPathData = ['M24 512c13.3 0 24-10.7 24-24 0-48.6 39.4-88 88-88l176 0c48.6 0 88 39.4 88 88 0 13.3 10.7 24 24 24L24 512zM160 160c0-35.3 28.7-64 64-64s64 28.7 64 64c0 12.1-3.3 23.4-9.2 33-11.7-5.8-24.9-9-38.8-9l-32 0c-13.9 0-27.1 3.2-38.8 9-5.8-9.6-9.2-20.9-9.2-33z', 'M80 160C80 80.5 144.5 16 224 16S368 80.5 368 160l0 112-80 0c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l184 0c13.3 0 24-10.7 24-24l0-136C416 54 330-32 224-32S32 54 32 160c0 13.3 10.7 24 24 24s24-10.7 24-24zm208 0c0 12.1-3.3 23.4-9.2 33 14.8 7.3 27.3 18.6 35.9 32.6 13.3-18.4 21.2-41.1 21.2-65.6 0-61.9-50.1-112-112-112S112 98.1 112 160c0 24.5 7.9 47.2 21.2 65.6 8.7-13.9 21.1-25.3 35.9-32.6-5.8-9.6-9.2-20.9-9.2-33 0-35.3 28.7-64 64-64s64 28.7 64 64zM48 488c0-48.6 39.4-88 88-88l176 0c48.6 0 88 39.4 88 88 0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136l-176 0c-75.1 0-136 60.9-136 136 0 13.3 10.7 24 24 24s24-10.7 24-24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserHeadset = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;